export default __webpack_public_path__ + "static/media/insta.0dd482fa.svg";